<template>
    <v-row>
        <v-col>
            <v-select :label="`${label}(년)`" v-model="year" :items="years" v-bind="inputProps" />
        </v-col>
        <v-col>
            <v-select label="(월)" v-model="month" :items="months" v-bind="inputProps" />
        </v-col>
        <v-col>
            <v-select label="(일)" v-model="day" :items="days" v-bind="inputProps" />
        </v-col>
    </v-row>
</template>

<script>
import dayjs from "dayjs";

const inputProps = {
    outlined: true,
    dense: true,
    "hide-details": true,
    persistentPlaceholder: true,
    class: "rounded-0",
};

export default {
    props: ["value", "label"],
    computed: {
        years() {
            const years = [];
            let year = dayjs().year();
            do {
                years.push(year);
                year -= 1;
            } while (year >= 1900);
            return years;
        },
        months() {
            const months = [];
            let month = 1;
            do {
                months.push(month);
                month += 1;
            } while (month <= 12);
            return months;
        },
        days() {
            const days = [];
            if (this.year && this.month) {
                let day = 1;
                const endDay = dayjs(`${this.year}-${String(this.month).padStart(2, 0)}-01`)
                    .endOf("month")
                    .date();
                do {
                    days.push(day);
                    day += 1;
                } while (day <= endDay);
            }
            return days;
        },
        date() {
            return `${this.year}-${String(this.month).padStart(2, 0)}-${String(this.month).padStart(2, 0)}`;
        },
    },
    data() {
        return {
            year: null,
            month: null,
            day: null,
            inputProps,
        };
    },
    methods: {
        init() {
            const date = dayjs(this.value).format("YYYY-MM-DD");
            [this.year, this.month, this.day] = date.split("-").map((item) => Number(item));
        },
        sync() {
            this.$emit("input", this.date);
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        value() {
            if (this.value !== this.date) this.init();
        },
        date() {
            if (this.value !== this.date) this.sync();
        },
    },
};
</script>

<style></style>
